import rehypeKatex from "rehype-katex";
import type { Options as ReactMarkdownOptions } from "react-markdown";
import remarkGfm from "remark-gfm";
import remarkMath from "remark-math";

import { remarkBreakTags } from "./markdown-break-tags";

export const markdownRemarkPlugins: NonNullable<
  ReactMarkdownOptions["remarkPlugins"]
> = [remarkGfm, [remarkMath, { singleDollarTextMath: false }], remarkBreakTags];

export const markdownRehypePlugins: NonNullable<
  ReactMarkdownOptions["rehypePlugins"]
> = [rehypeKatex];
